export default __webpack_public_path__ + "static/media/loyola9.69cd921c.jpg";